export default {
    titulo: "Repuestos",
    nuevo: "Nuevo repuesto",
    editar: "Editar repuesto",
    buscar: "Buscar por nro parte, código de barras o descripción",
    eliminar: "Eliminar repuesto",
    pregEliminar: "¿Confirmas que deseas eliminar el repuesto?",
    cantidad: "Cantidad",
    msgStock: "No hay stock disponible",
    nroSerie: "Número de serie",
    textAplicaNumSerie: "Al comprar el repuesto solicita números de series",
    precio1: "Precio de venta 1",
    precio2: "Precio de venta 2",
    stockMinimo: "Stock mínimo",
    impuesto: "Impuesto",
    stockPorSucursal: "Stock de repuestos por sucursal",
    familias: "Familias",
    nuevaFamilia: "Nueva familia",
    editarFamilia: "Editar familia",
    eliminarFamilia: "Eliminar familia",
    pregEliminarFamilia: "¿Confirmas que deseas eliminar la familia?"
}